import Autosuggest, { AutosuggestProps } from '../Autosuggest'

export type SelectProps<Item> = Omit<AutosuggestProps<Item>, 'value' | 'onChange' | 'multiple'> & {
  value: Item | null
  onChange: (value: Item | null) => void
  isNotNullable?: boolean
}

export function Select<Item extends { id: string }>({ value, onChange, isNotNullable, ...props }: SelectProps<Item>) {
  return (
    <Autosuggest<Item>
      value={value ? [value] : []}
      onChange={([value]) => {
        if (!isNotNullable || value) {
          onChange(value ?? null)
        }
      }}
      {...props}
      multiple={false}
    />
  )
}
